// Tiny blur placeholder for next/image `blurDataURL`.
//
// IMPORTANT: this value is inlined into the server-rendered HTML once PER IMAGE
// that uses `placeholder="blur" blurDataURL={gifImage}`. It MUST stay tiny.
//
// It previously held an ~832 KB base64 GIF, which was embedded for every image
// on the page. Item pages render multiple images, so the HTML ballooned to
// ~1.8 MB (up to 5 MB+ for image-heavy items) — exceeding AWS Amplify's ~6 MB
// SSR response limit and returning HTTP 413. Because the 413 fired for
// cookieless requests too, Googlebot could not render those pages, which is why
// they showed up as "Crawled - currently not indexed" in Search Console.
//
// This is the canonical 1x1 transparent GIF (~43 bytes decoded). If a visible
// shimmer is wanted later, use a sub-1 KB inline SVG/CSS shimmer instead - never
// a large raster data URI here.
export const gifImage =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
